import { PartialAssetFields } from "src/api/fragments";
import { AccountFilterType, LabelFilterType } from "src/hooks";
import * as yup from "yup";

export type AssetOption = {
  value: string;
  label: string;
  assets: PartialAssetFields[];
  isUnnamedAsset: boolean;
};

export type FormValues = {
  search: string;
  startDate: string | null;
  endDate: string | null;
  accounts: any[] | null;
  providers: any[] | null;
  providerFilterMode: AccountFilterType | null;
  labelFilterMode: LabelFilterType | null;
  isMissingBasis: boolean | null;
  onlyShowDeleted: boolean | null;
  showOnlyEditedTransactions: boolean | null;
  onlyWashSales: boolean | null;
  isNegativeBalance: boolean | null;
  hasIncome: boolean | null;
  hasNotes: boolean | null;
  assets: AssetOption[] | null;
  assetType: any | null;
  reviewed: any | null;
  gainLossFilter: any | null;
  labels: any[] | null;
};

export const schema = yup.object().shape({
  search: yup.string().nullable(),
  startDate: yup.string().nullable(),
  endDate: yup.string().nullable(),
  accounts: yup.array().nullable(),
  providers: yup.array().nullable(),
  providerFilterMode: yup.string().nullable(),
  labelFilterMode: yup.string().nullable(),
  isMissingBasis: yup.boolean().nullable(),
  onlyShowDeleted: yup.boolean().nullable(),
  showOnlyEditedTransactions: yup.boolean().nullable(),
  isNegativeBalance: yup.boolean().nullable(),
  onlyWashSales: yup.boolean().nullable(),
  hasIncome: yup.boolean().nullable(),
  hasNotes: yup.boolean().nullable(),
  assets: yup.array().nullable(),
  assetType: yup.object().nullable(),
  reviewed: yup.object().nullable(),
  gainLossFilter: yup.object().nullable(),
  labels: yup.array().nullable(),
});

export const getDefaultValues = (values: Partial<FormValues>): FormValues => ({
  search: values.search || "",
  startDate: values.startDate || null,
  endDate: values.endDate || null,
  accounts: values.accounts || null,
  providers: values.providers || null,
  providerFilterMode: values.providerFilterMode || null,
  labelFilterMode: values.labelFilterMode || null,
  isMissingBasis: values.isMissingBasis || null,
  onlyShowDeleted: values.onlyShowDeleted || null,
  showOnlyEditedTransactions: values.showOnlyEditedTransactions || null,
  isNegativeBalance: values.isNegativeBalance || null,
  hasIncome: values.hasIncome || null,
  hasNotes: values.hasNotes || null,
  assets: values.assets || null,
  assetType: values.assetType || null,
  reviewed: values.reviewed || null,
  gainLossFilter: values.gainLossFilter || null,
  labels: values.labels || null,
  onlyWashSales: values.onlyWashSales || null,
});
